(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pipet-passear-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pipet-walk-carousel')) {
  customElements.define('pipet-walk-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pp-walk-products__grid');
      this.controls = this.querySelector('.pp-walk-products__controls');
      this.previous = this.querySelector('[data-walk-previous]');
      this.next = this.querySelector('[data-walk-next]');
      if (!this.track || !this.controls || !this.previous || !this.next) return;
      this.onScroll = () => this.updateControls();
      this.onPrevious = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.previous.addEventListener('click', this.onPrevious);
      this.next.addEventListener('click', this.onNext);
      this.observer = new ResizeObserver(() => this.updateControls());
      this.observer.observe(this.track);
      this.updateControls();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.track?.removeEventListener('scroll', this.onScroll);
      this.previous?.removeEventListener('click', this.onPrevious);
      this.next?.removeEventListener('click', this.onNext);
    }
    updateControls() {
      const end = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      this.controls.hidden = end <= 2;
      this.previous.disabled = position <= 2;
      this.next.disabled = position >= end - 2;
    }
    move(direction) {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      this.track.scrollBy({
        left: direction * rtl * (this.track.clientWidth + gap),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
